import { FiberRefTypeId as FiberRefTypeId$1, fiberRefUnsafeMake, fiberRefUnsafeMakeHashSet, fiberRefUnsafeMakeContext, fiberRefUnsafeMakePatch, fiberRefGet, fiberRefGetAndSet, fiberRefGetAndUpdate, fiberRefGetAndUpdateSome, fiberRefGetWith, fiberRefSet, fiberRefDelete, fiberRefReset, fiberRefModify, fiberRefModifySome, fiberRefUpdate, fiberRefUpdateSome, fiberRefUpdateAndGet, fiberRefUpdateSomeAndGet, currentRequestBatching, currentContext as currentContext$1, currentSchedulingPriority as currentSchedulingPriority$1, currentMaxOpsBeforeYield as currentMaxOpsBeforeYield$1, currentUnhandledErrorLogLevel, currentLogAnnotations as currentLogAnnotations$1, currentLogLevel as currentLogLevel$1, currentLogSpan as currentLogSpan$1, currentMetricLabels as currentMetricLabels$1, currentTracerSpan as currentTracerSpan$1, currentTracerTimingEnabled as currentTracerTimingEnabled$1, currentTracerSpanAnnotations as currentTracerSpanAnnotations$1, currentTracerSpanLinks as currentTracerSpanLinks$1, currentInterruptedCause } from '../../internal/core.esm.js';
import { fiberRefMake, fiberRefMakeWith, fiberRefMakeContext, fiberRefMakeRuntimeFlags, fiberRefUnsafeMakeSupervisor, currentLoggers as currentLoggers$1, currentMinimumLogLevel as currentMinimumLogLevel$1, currentRuntimeFlags as currentRuntimeFlags$1, currentSupervisor as currentSupervisor$1 } from '../../internal/fiberRuntime.esm.js';
import { currentCache, currentCacheEnabled } from '../../internal/query.esm.js';
import { currentScheduler as currentScheduler$1 } from '../../Scheduler/dist/effect-Scheduler.esm.js';

/**
 * @since 2.0.0
 */
/**
 * @since 2.0.0
 * @category symbols
 */
const FiberRefTypeId = FiberRefTypeId$1;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * @since 2.0.0
 * @category model
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category constructors
 */
const make = fiberRefMake;

/**
 * @since 2.0.0
 * @category constructors
 */
const makeWith = fiberRefMakeWith;

/**
 * @since 2.0.0
 * @category constructors
 */
const makeContext = fiberRefMakeContext;

/**
 * @since 2.0.0
 * @category constructors
 */
const makeRuntimeFlags = fiberRefMakeRuntimeFlags;

/**
 * @since 2.0.0
 * @category constructors
 */
const unsafeMake = fiberRefUnsafeMake;

/**
 * @since 2.0.0
 * @category constructors
 */
const unsafeMakeHashSet = fiberRefUnsafeMakeHashSet;

/**
 * @since 2.0.0
 * @category constructors
 */
const unsafeMakeContext = fiberRefUnsafeMakeContext;

/**
 * @since 2.0.0
 * @category constructors
 */
const unsafeMakeSupervisor = fiberRefUnsafeMakeSupervisor;

/**
 * @since 2.0.0
 * @category constructors
 */
const unsafeMakePatch = fiberRefUnsafeMakePatch;

/**
 * @since 2.0.0
 * @category getters
 */
const get = fiberRefGet;

/**
 * @since 2.0.0
 * @category utils
 */
const getAndSet = fiberRefGetAndSet;

/**
 * @since 2.0.0
 * @category utils
 */
const getAndUpdate = fiberRefGetAndUpdate;

/**
 * @since 2.0.0
 * @category utils
 */
const getAndUpdateSome = fiberRefGetAndUpdateSome;

/**
 * @since 2.0.0
 * @category utils
 */
const getWith = fiberRefGetWith;

/**
 * @since 2.0.0
 * @category utils
 */
const set = fiberRefSet;
const _delete = fiberRefDelete;

/**
 * @since 2.0.0
 * @category utils
 */
const reset = fiberRefReset;

/**
 * @since 2.0.0
 * @category utils
 */
const modify = fiberRefModify;

/**
 * @since 2.0.0
 * @category utils
 */
const modifySome = fiberRefModifySome;

/**
 * @since 2.0.0
 * @category utils
 */
const update = fiberRefUpdate;

/**
 * @since 2.0.0
 * @category utils
 */
const updateSome = fiberRefUpdateSome;

/**
 * @since 2.0.0
 * @category utils
 */
const updateAndGet = fiberRefUpdateAndGet;

/**
 * @since 2.0.0
 * @category utils
 */
const updateSomeAndGet = fiberRefUpdateSomeAndGet;

/**
 * @since 2.0.0
 * @category fiberRefs
 */
const currentRequestBatchingEnabled = currentRequestBatching;

/**
 * @since 2.0.0
 * @category fiberRefs
 */
const currentRequestCache = currentCache;

/**
 * @since 2.0.0
 * @category fiberRefs
 */
const currentRequestCacheEnabled = currentCacheEnabled;

/**
 * @since 2.0.0
 * @category fiberRefs
 */
const currentContext = currentContext$1;

/**
 * @since 2.0.0
 * @category fiberRefs
 */
const currentSchedulingPriority = currentSchedulingPriority$1;

/**
 * @since 2.0.0
 * @category fiberRefs
 */
const currentMaxOpsBeforeYield = currentMaxOpsBeforeYield$1;

/**
 * @since 2.0.0
 * @category fiberRefs
 */
const unhandledErrorLogLevel = currentUnhandledErrorLogLevel;

/**
 * @since 2.0.0
 * @category fiberRefs
 */
const currentLogAnnotations = currentLogAnnotations$1;

/**
 * @since 2.0.0
 * @category fiberRefs
 */
const currentLoggers = currentLoggers$1;

/**
 * @since 2.0.0
 * @category fiberRefs
 */
const currentLogLevel = currentLogLevel$1;

/**
 * @since 2.0.0
 * @category fiberRefs
 */
const currentMinimumLogLevel = currentMinimumLogLevel$1;

/**
 * @since 2.0.0
 * @category fiberRefs
 */
const currentLogSpan = currentLogSpan$1;

/**
 * @since 2.0.0
 * @category fiberRefs
 */
const currentRuntimeFlags = currentRuntimeFlags$1;

/**
 * @since 2.0.0
 * @category fiberRefs
 */
const currentScheduler = currentScheduler$1;

/**
 * @since 2.0.0
 * @category fiberRefs
 */
const currentSupervisor = currentSupervisor$1;

/**
 * @since 2.0.0
 * @category fiberRefs
 */
const currentMetricLabels = currentMetricLabels$1;

/**
 * @since 2.0.0
 * @category fiberRefs
 */
const currentTracerSpan = currentTracerSpan$1;

/**
 * @since 2.0.0
 * @category fiberRefs
 */
const currentTracerTimingEnabled = currentTracerTimingEnabled$1;

/**
 * @since 2.0.0
 * @category fiberRefs
 */
const currentTracerSpanAnnotations = currentTracerSpanAnnotations$1;

/**
 * @since 2.0.0
 * @category fiberRefs
 */
const currentTracerSpanLinks = currentTracerSpanLinks$1;

/**
 * @since 2.0.0
 * @category fiberRefs
 */
const interruptedCause = currentInterruptedCause;

export { FiberRefTypeId, currentContext, currentLogAnnotations, currentLogLevel, currentLogSpan, currentLoggers, currentMaxOpsBeforeYield, currentMetricLabels, currentMinimumLogLevel, currentRequestBatchingEnabled, currentRequestCache, currentRequestCacheEnabled, currentRuntimeFlags, currentScheduler, currentSchedulingPriority, currentSupervisor, currentTracerSpan, currentTracerSpanAnnotations, currentTracerSpanLinks, currentTracerTimingEnabled, _delete as delete, get, getAndSet, getAndUpdate, getAndUpdateSome, getWith, interruptedCause, make, makeContext, makeRuntimeFlags, makeWith, modify, modifySome, reset, set, unhandledErrorLogLevel, unsafeMake, unsafeMakeContext, unsafeMakeHashSet, unsafeMakePatch, unsafeMakeSupervisor, update, updateAndGet, updateSome, updateSomeAndGet };
